// @ts-ignore
import * as timesync from 'timesync';
import {HOST_API} from "../config-global";

let ts: any;

export const serverTimeNow = () => {
  if (!ts) {
    ts = timesync.create({
      server: `${HOST_API}/time-sync`,
      interval: 600000,
      repeat: 1,
    });
  }
  return ts.now();
}
